<template>
  <div>
    <b-row>
      <b-col
        v-for="item in dataList"
        :key="item"
        cols="12"
        md="4"
      >
        <b-card>
          <b-row>
            <b-col cols="12">
              <div class="text-center p-3 font-medium-2 text-primary font-weight-bold bg-light mb-2">
                {{ item.title }}
              </div>
            </b-col>
            <b-col
              cols="12"
            >
              <b-button
                variant="light"
                block
                :to="item.live_url"
              >
                <FeatherIcon icon="TrendingUpIcon" />
                Canlı İzleme
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!--    <dashboard />-->
  </div>
</template>

<script>
// import { getMessaging, getToken } from 'firebase/messaging'
// import Dashboard from '@/views/Dashboard/Index.vue'
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
  },
  computed: {
    dataList() {
      return [
        {
          id: 1, title: 'Sıfır Satış', live_url: '/live-dashboard/sales', report_url: '',
        },
        {
          id: 2, title: '2. El Satış', live_url: '/live-dashboard/i2-sales', report_url: '',
        },
        {
          id: 3, title: 'Servis', live_url: '/live-dashboard/service', report_url: '',
        },
        {
          id: 4, title: 'Sigorta', live_url: '/live-dashboard/insurances', report_url: '',
        },
        {
          id: 5, title: 'Müşteri Deneyimi', live_url: '/live-dashboard/crm', report_url: '',
        },
        {
          id: 6, title: 'Gayrimenkul', live_url: '/live-dashboard/realty-sales', report_url: '',
        },
      ]
    },
  },
}
</script>
<style>
.dashboard-report-card-bg{
  background-color: #f1f1f1;
  border-radius: 5px;
  margin-bottom: 30px;
  font-size: 18px;
}
</style>
